import * as optimizelySDK from '@optimizely/optimizely-sdk/dist/optimizely.browser.umd';

// Within config/environment.js, "optimizely.enableLogging = false" turns off all logging.
export function initialize(instance) {
  const config = instance.factoryFor('config:environment').class || {};
  const environmentOptimizelyConfig = config.optimizely || {};

  if (environmentOptimizelyConfig.enableLogging === false) {
    optimizelySDK.setLogger(null);
  }
}

export default { initialize };
